import ReactDOM from 'react-dom/client'
import './styles/markdown-overwrites.css'
import './styles/discussion-forum.css'
import './styles/resume-builder.css'
import "driver.js/dist/driver.css"
import './styles/file-upload.css'
import './styles/animations.css'
import './styles/driver-js.css'
import './styles/graphs.css'
import './styles/index.css'
import './styles/video.css'
import React from 'react'
import App from './App'

const root = ReactDOM.createRoot( document.getElementById( 'root' ) )

if ( 'serviceWorker' in navigator ) {
  window.addEventListener( 'load', () => {
    navigator.serviceWorker
      .register( '/activityreport-service-worker.js' )
      .then( registration => {
        console.log( 'Service Worker registered with scope:', registration.scope )
      } )
      .catch( error => {
        console.error( 'Service Worker registration failed:', error )
      } )
  } )
}

function setVh () {
  document.documentElement.style.setProperty( '--vh', `${window.innerHeight * 0.01}px` )
}

// run once on load
setVh()

// add listener
window.addEventListener( 'resize', setVh )

// if you want to be extra safe in dev (HMR), clean it up:
if ( import.meta.hot ) {
  import.meta.hot.dispose( () => {
    window.removeEventListener( 'resize', setVh )
  } )
}


root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
)
